import {isNotNil} from 'ramda';

import {LegalForm} from '@dms/api/customer';

import {Nullish} from 'shared/web';

import {getConsentContactPersonRequirement} from './getConsentContactPersonRequirement';

/**
 * Tells whether a consent can be created for billing information without choosing a contact person,
 * e.g. in checkout where the contact person of the business case is used. A legal entity needs one.
 */
export const canCreateConsentForContactPerson = (
  legalForm: LegalForm | Nullish,
  contactPersonId: string | Nullish
) =>
  isNotNil(legalForm) &&
  (getConsentContactPersonRequirement(legalForm) !== 'required' || isNotNil(contactPersonId));
